module.exports = __webpack_public_path__ + "static/media/fareLockPadlock.3d142f8f.svg";